import { DefaultTrackPromotionEvent } from '@/common/analytics/gtm/shared/trackViewPromotion';
import { HomepageFeaturedCollection } from 'generatedBfw/static';

export type FeaturedCollectionsTrackPromotionEvent = Omit<
  DefaultTrackPromotionEvent,
  'creative_size' | 'creative_name'
>;

export const createFeaturedCollections = (
  event: HomepageFeaturedCollection,
  index: number,
): FeaturedCollectionsTrackPromotionEvent => {
  return {
    promotion_id: `collection|top_collections|${event.collection.id}`,
    promotion_name: `${event.author.name}|${event.collection.title}`,
    promotion_type: 'collection',
    creative_slot: `collections_top|${index}`,
  };
};
